<template>
  <div class="card-custom" v-if="pieChartData">
    <div class="md-layout">
      <p class="pt-5 pb-3 md-layout-item md-size-100 flex">
        <span v-html="option.questionText"></span>
        <span v-if="option.is_require" class="text-[#F44336] pl-2">*</span>
      </p>
      <div class="md-layout-item md-size-55">
        <p class="pb-5 ">
          {{ option.responses }} {{ $t("survey_report.responses") }}
        </p>
        <pie-chart
          v-if="chartData"
          key="chartData"
          :chart-data="chartData"
          :tooltips-callback-cfg="tooltipsCallbackCfg"
          :legendCfg="{
            position: 'right'
          }"
        ></pie-chart>
      </div>
      <div class="md-layout-item md-size-45">
        <a class="pb-5 cursor-pointer more-detail" @click="showDetailModal">
          {{ $t("survey_report.more_detail") }}
        </a>
        <md-table class="detail-piechart">
          <md-table-head
            ><span class="text-white">{{
              $t("survey_report.option")
            }}</span></md-table-head
          >
          <md-table-head
            ><span class="text-white">{{
              $t("survey_report.percentage")
            }}</span></md-table-head
          >
          <md-table-head
            ><span class="text-white">
              {{ $t("survey_report.number_of_answers") }}
            </span></md-table-head
          >
          <template v-if="label">
            <md-table-row v-for="(item, index) in label" :key="index + item">
              <md-table-cell class="text-center">{{ item.text }}</md-table-cell>
              <md-table-cell class="text-center">
                {{
                  percent_chart[index] ? percent_chart[index].toFixed(2) : "0"
                }}%</md-table-cell
              >
              <md-table-cell class="text-center">{{
                data[index] || "0"
              }}</md-table-cell>
            </md-table-row>
          </template>
        </md-table>
      </div>
    </div>
    <common-modal
      :name="modalName"
      height="auto"
      :hideFooter="true"
      :hideHeader="true"
      width="80%"
    >
      <template #modal-body>
        <AnswerDetailModal
          :modalName="modalName"
          :questionTitle="option.questionText"
        >
        </AnswerDetailModal>
      </template>
    </common-modal>
  </div>
</template>
<script>
import AnswerDetailModal from "./AnswerDetailModal";
import PieChart from "@/components/Base/PieChart";
import {
  COLOR_SURVEY_ANSWER,
  COLOR_SURVEY_ANSWER_OPTION
} from "@/helpers/color-chart-config";
export default {
  components: { PieChart, AnswerDetailModal },
  props: ["pieChartData", "option", "index"],
  data() {
    return {
      label: null,
      data: [],
      percent_chart: [],
      tooltipsCallbackCfg: {
        title: {
          prefix: this.$t("survey_report.question")
        },
        label: true,
        afterLabel: {
          subfix: this.$t("survey_report.number_of_answers")
        }
      }
    };
  },
  computed: {
    chartData() {
      return this.generateGenderChart(this.pieChartData);
    },
    chartBackground() {
      return this.option.hasChoice
        ? this.label.map(
            (label, index) => COLOR_SURVEY_ANSWER_OPTION[index + 1]
          )
        : this.label.map(label => COLOR_SURVEY_ANSWER[label.text]);
    },
    modalName() {
      return `SurveyQuestionDetailModal${this.index}`;
    },
    modalTitle() {
      return `${this.$t("survey_report.responded_detail")} : ${
        this.option.questionText
      }`;
    }
  },
  methods: {
    showDetailModal() {
      this.$modal.show(this.modalName);
    },
    generateGenderChart(pieChartData) {
      if (!pieChartData) return null;
      this.label = pieChartData.label;
      this.data = pieChartData.data;
      this.percent_chart = pieChartData.percent_chart;
      return {
        labels: this.label.map(item => item.text),
        datasets: [
          {
            data: this.data,
            backgroundColor: this.chartBackground,
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.detail-piechart {
  margin-top: 4px;
  .md-table-head {
    background-color: #e39157;
  }
}
.md-table-head {
  padding: 12px 8px;
  text-align: center;
  border: 0.5px solid #b8b7b7;
}
.md-table-cell {
  border: 0.5px solid #b8b7b7;
}
.more-detail {
  font-weight: 500;
  font-size: 16px;
  line-height: 132%;
  text-decoration-line: underline;
  color: #0032e3 !important;
}
.card-custom {
  background: #ffffff;
  border-radius: 16px;
  margin: 24px 0;
  padding-bottom: 24px;
}
</style>
